var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { assertMonth } from '../../shared/date-types';
import styles from '../../shared/sds-datepicker-item/_sds-date-picker-base.lit.scss';
import '../../year/year-page-navigation/year-page-navigation.lit';
import '../month-page-view/month-page-view.lit';
import { monthKeyToDate } from '../month-picker-calculations';
import { sdsCustomElement } from '../../../utilities/custom-components';
/**
 * Control represents a month picker
 */
let SdsInnerMonthPicker = (() => {
    var _SdsInnerMonthPicker_navigationState_accessor_storage, _SdsInnerMonthPicker_yearPageNavigation_accessor_storage, _SdsInnerMonthPicker_pageYear_accessor_storage, _SdsInnerMonthPicker_currentMonth_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-inner-month-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _navigationState_decorators;
    let _navigationState_initializers = [];
    let _navigationState_extraInitializers = [];
    let _yearPageNavigation_decorators;
    let _yearPageNavigation_initializers = [];
    let _yearPageNavigation_extraInitializers = [];
    let _pageYear_decorators;
    let _pageYear_initializers = [];
    let _pageYear_extraInitializers = [];
    let _currentMonth_decorators;
    let _currentMonth_initializers = [];
    let _currentMonth_extraInitializers = [];
    var SdsInnerMonthPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInnerMonthPicker_navigationState_accessor_storage.set(this, __runInitializers(this, _navigationState_initializers, 'SelectMonth'));
            _SdsInnerMonthPicker_yearPageNavigation_accessor_storage.set(this, (__runInitializers(this, _navigationState_extraInitializers), __runInitializers(this, _yearPageNavigation_initializers, void 0)));
            this.monthMapper = __runInitializers(this, _yearPageNavigation_extraInitializers);
            _SdsInnerMonthPicker_pageYear_accessor_storage.set(this, __runInitializers(this, _pageYear_initializers, new Date().getFullYear()));
            _SdsInnerMonthPicker_currentMonth_accessor_storage.set(this, (__runInitializers(this, _pageYear_extraInitializers), __runInitializers(this, _currentMonth_initializers, void 0)));
            this.changeYearPage = (__runInitializers(this, _currentMonth_extraInitializers), (event) => {
                this.changeYearPageBy(event.detail.step);
            });
            this.yearSelect = (e) => {
                this.updatePageIndex(e.detail.year);
                this.navigateTo('SelectMonth');
                this.dispatchYearChangedEvent(e.detail.year);
            };
            this.yearPageChangedHandler = (event) => {
                this.yearPageNavigation.startYear = event.detail.firstYearInPage;
                this.yearPageNavigation.endYear = event.detail.lastYearInPage;
            };
            this.itemSelectHandler = (event) => {
                this.updateSelectedMonth(event.detail.month, this.pageYear);
            };
            this.itemHoverHandler = (event) => {
                this.dispatchEvent(new CustomEvent(SdsInnerMonthPicker.INNER_MONTH_PICKER_HOVER_EVENT, {
                    detail: {
                        month: event.detail.month ? [this.pageYear, event.detail.month] : undefined,
                    },
                }));
            };
        }
        get navigationState() { return __classPrivateFieldGet(this, _SdsInnerMonthPicker_navigationState_accessor_storage, "f"); }
        set navigationState(value) { __classPrivateFieldSet(this, _SdsInnerMonthPicker_navigationState_accessor_storage, value, "f"); }
        get yearPageNavigation() { return __classPrivateFieldGet(this, _SdsInnerMonthPicker_yearPageNavigation_accessor_storage, "f"); }
        set yearPageNavigation(value) { __classPrivateFieldSet(this, _SdsInnerMonthPicker_yearPageNavigation_accessor_storage, value, "f"); }
        get pageYear() { return __classPrivateFieldGet(this, _SdsInnerMonthPicker_pageYear_accessor_storage, "f"); }
        set pageYear(value) { __classPrivateFieldSet(this, _SdsInnerMonthPicker_pageYear_accessor_storage, value, "f"); }
        /** currentMonth is {year}/{month} format */
        get currentMonth() { return __classPrivateFieldGet(this, _SdsInnerMonthPicker_currentMonth_accessor_storage, "f"); }
        set currentMonth(value) { __classPrivateFieldSet(this, _SdsInnerMonthPicker_currentMonth_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="sds-date-picker">
                ${this.renderNavigation()}
                <div>${this.renderCalendar()}</div>
            </div>
        `;
        }
        renderNavigation() {
            switch (this.navigationState) {
                case 'SelectYear':
                    return this.renderYearNavigation();
                case 'SelectMonth':
                    return this.renderMonthNavigation();
            }
        }
        renderCalendar() {
            const currentYear = this.currentMonth
                ? monthKeyToDate(this.currentMonth)[0]
                : new Date().getFullYear();
            switch (this.navigationState) {
                case 'SelectMonth':
                    return html ` <sds-month-page-view
                    @sds.month-page-view.select="${this.itemSelectHandler}"
                    @sds.month-page-view.hovered="${this.itemHoverHandler}"
                    pageYear="${this.pageYear}"
                    currentMonth="${this.currentMonth}"
                >
                </sds-month-page-view>`;
                case 'SelectYear':
                    return html ` <sds-year-page-view
                    @sds.year-page-view.select="${this.yearSelect}"
                    @sds.year-page-view.page-changed="${this.yearPageChangedHandler}"
                    currentYear="${currentYear}"
                >
                </sds-year-page-view>`;
            }
        }
        renderYearNavigation() {
            return html `
            <sds-year-page-navigation
                @sds.year-page-navigation.page-changed="${this.changeYearPage}"
            >
            </sds-year-page-navigation>
        `;
        }
        renderMonthNavigation() {
            return html `
            <div class="sds-date-picker-toolbar">
                <sds-button
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_left_thin"
                    @click="${() => this.changeMonthPageBy(-1)}"
                ></sds-button>
                <sds-button
                    id="select-year"
                    label="${this.pageYear}"
                    type="tertiary"
                    size="sm"
                    @click="${() => this.navigateTo('SelectYear')}"
                ></sds-button>
                <sds-button
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_right_thin"
                    @click="${() => this.changeMonthPageBy(1)}"
                ></sds-button>
            </div>
        `;
        }
        /**
         * state mapper for month, this value is delegated to sds-month-page-view
         */
        setMonthStateMapper(stateMapper) {
            this.monthMapper = stateMapper;
            this.syncMappers();
        }
        /**
         * state for year, this value is delegated to sds-year-page-view
         */
        setYearStateMapper(stateMapper) {
            this.yearMapper = stateMapper;
            this.syncMappers();
        }
        updated() {
            this.syncMappers();
            this.setYearViewPage();
        }
        setYearViewPage() {
            var _a, _b;
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-year-page-view')) === null || _b === void 0 ? void 0 : _b.openPageFor(this.pageYear);
        }
        syncMappers() {
            var _a, _b, _c, _d;
            if (this.monthMapper) {
                (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-month-page-view')) === null || _b === void 0 ? void 0 : _b.setMonthStateMapper(this.monthMapper);
            }
            if (this.yearMapper) {
                (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('sds-year-page-view')) === null || _d === void 0 ? void 0 : _d.setYearStateMapper(this.yearMapper);
            }
        }
        navigateTo(navigationState) {
            const oldValue = this.navigationState;
            this.navigationState = navigationState;
            this.requestUpdate('navigationState', oldValue);
        }
        changeYearPageBy(diff) {
            var _a, _b;
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-year-page-view')) === null || _b === void 0 ? void 0 : _b.goByPage(diff);
        }
        changeMonthPageBy(diff) {
            this.updatePageIndex(this.pageYear + diff);
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        updateValue(selectedMonth, year) {
            this.dispatchEvent(new CustomEvent(SdsInnerMonthPicker.INNER_MONTH_PICKER_CHANGE_EVENT, {
                detail: {
                    month: selectedMonth,
                    year: year,
                },
            }));
        }
        dispatchYearChangedEvent(year) {
            this.dispatchEvent(new CustomEvent(SdsInnerMonthPicker.INNER_MONTH_PICKER_YEAR_CHANGED_EVENT, {
                detail: {
                    year: year,
                },
            }));
        }
        updateSelectedMonth(month, year) {
            this.updateValue(assertMonth(month), year);
        }
        updatePageIndex(pageYear) {
            if (pageYear !== undefined) {
                this.pageYear = pageYear;
            }
        }
    };
    _SdsInnerMonthPicker_navigationState_accessor_storage = new WeakMap();
    _SdsInnerMonthPicker_yearPageNavigation_accessor_storage = new WeakMap();
    _SdsInnerMonthPicker_pageYear_accessor_storage = new WeakMap();
    _SdsInnerMonthPicker_currentMonth_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInnerMonthPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _navigationState_decorators = [state()];
        _yearPageNavigation_decorators = [query('sds-year-page-navigation')];
        _pageYear_decorators = [property({ type: Number })];
        _currentMonth_decorators = [property()];
        __esDecorate(_classThis, null, _navigationState_decorators, { kind: "accessor", name: "navigationState", static: false, private: false, access: { has: obj => "navigationState" in obj, get: obj => obj.navigationState, set: (obj, value) => { obj.navigationState = value; } }, metadata: _metadata }, _navigationState_initializers, _navigationState_extraInitializers);
        __esDecorate(_classThis, null, _yearPageNavigation_decorators, { kind: "accessor", name: "yearPageNavigation", static: false, private: false, access: { has: obj => "yearPageNavigation" in obj, get: obj => obj.yearPageNavigation, set: (obj, value) => { obj.yearPageNavigation = value; } }, metadata: _metadata }, _yearPageNavigation_initializers, _yearPageNavigation_extraInitializers);
        __esDecorate(_classThis, null, _pageYear_decorators, { kind: "accessor", name: "pageYear", static: false, private: false, access: { has: obj => "pageYear" in obj, get: obj => obj.pageYear, set: (obj, value) => { obj.pageYear = value; } }, metadata: _metadata }, _pageYear_initializers, _pageYear_extraInitializers);
        __esDecorate(_classThis, null, _currentMonth_decorators, { kind: "accessor", name: "currentMonth", static: false, private: false, access: { has: obj => "currentMonth" in obj, get: obj => obj.currentMonth, set: (obj, value) => { obj.currentMonth = value; } }, metadata: _metadata }, _currentMonth_initializers, _currentMonth_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInnerMonthPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.INNER_MONTH_PICKER_CHANGE_EVENT = 'sds.inner-month-picker.changed';
    _classThis.INNER_MONTH_PICKER_HOVER_EVENT = 'sds.inner-month-picker.hovered';
    _classThis.INNER_MONTH_PICKER_YEAR_CHANGED_EVENT = 'sds.inner-month-picker.year-changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInnerMonthPicker = _classThis;
})();
export { SdsInnerMonthPicker };
